import AppConfig from '../appConfig';
import AbstractFetch from './AbstractFetch';
import { moduleConfig } from '../lib/config/appConstants';

class FavoriteFetch extends AbstractFetch {
  static getAll() {
    return AbstractFetch.fetch(AppConfig.apiUrl + '/v1/favorites/' + moduleConfig.PC.productCode, {
      method: 'GET',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
      },
    }).then((response) => {
      return response.json();
    });
  }

  static save(data) {
    return AbstractFetch.fetch(AppConfig.apiUrl + '/v1/favorites/' + moduleConfig.PC.productCode, {
      method: 'POST',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((response) => {
      return response.json();
    });
  }

  static import(data) {
    return AbstractFetch.fetch(AppConfig.apiUrl + '/v1/favorites/import', {
      method: 'POST',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((response) => {
      return response.json();
    });
  }

  static delete(id) {
    return AbstractFetch.fetch(
      AppConfig.apiUrl + '/v1/favorites/' + moduleConfig.PC.productCode + '/' + id,
      {
        method: 'DELETE',
        cache: 'no-cache',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    ).then((response) => {
      return response.json();
    });
  }

  static update(data) {
    return AbstractFetch.fetch(
      AppConfig.apiUrl + '/v1/favorites/' + moduleConfig.PC.productCode + '/' + data['id'],
      {
        method: 'PUT',
        cache: 'no-cache',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }
    ).then((response) => {
      return response.json();
    });
  }
}

export default FavoriteFetch;
